import React, { useEffect, useState } from 'react'
import { HashLink } from 'react-router-hash-link'
import styled from 'styled-components'
import Search from '../../components/search'
import Lnb from '../../components/lnb'
import { minishopAPI } from "common/api/minishop";

const Main = () => {
    const hash = window.location.hash
    const [logoImg, setLogoImg] = useState({
        mobileLogo: '',
        mobileSeasonLogo: ''
    })
    let idx_b_manager = '1';

    const handleGetLogo = async (idx_b_manager) => {
        const { data } = await minishopAPI.getMinishopLogo(idx_b_manager)
        const { mobileLogo, mobileSeasonLogo } = data.result
        setLogoImg({
            mobileLogo, mobileSeasonLogo
        })
    }
    // const handleImgError = (e) => {
    //     e.target.src = logoImg.mobileLogo;
    // }

    useEffect(() => {
        handleGetLogo(idx_b_manager)
    },[])

    return (
        <>
            <MainStyle className="header_component_head">
                <HashLink to={`${hash === '#aside' ? '#' : '#aside'}`}>
                    <AllMenu className="header_component_menu" />
                </HashLink>
                <a href={process.env.REACT_APP_M_URL}>
                    <Image >
                        {logoImg.mobileLogo &&
                            <img
                                src={logoImg.mobileLogo}
                                title='_행복쇼핑'
                                alt='행복쇼핑'
                                width='36px'
                                height='36px'
                                // src={logoImg.mobileSeasonLogo}
                                // onError={handleImgError}
                            />
                        }
                    </Image>
                </a>
                <Search />
                <Cart href={process.env.REACT_APP_CART_URL} className="header_component_cart" />
            </MainStyle>
            <Lnb />
        </>
    )
}

const MainStyle = styled.div`
    position: relative;
    height: 64px;
    padding: 14px 0 0;
`
const AllMenu = styled.button`
    position: absolute;
    top: 14px;
    left: 14px;
    border: 0;
    background: none;
    width: 36px;
    height: 36px;
    padding: 8px 7px;

    &:after {
        overflow: hidden;
        display: block;
        position: relative;
        font-family: 'ppingkr_v4';
        content: '\\ea2d';
        color: #333;
        font-size: 17px;
        width: 22px;
    }
`

const Image = styled.div`
  position: absolute;
  top: 14px;
  left: 64px;
  width: 36px;
  height: 36px;
  .img{
    width: 36px;
    height: 36px;
  }
`
const Cart = styled.a`
    position: absolute;
    top: 14px;
    right: 17px;
    width: 36px;
    height: 36px;

    &:before {
        font-family: 'ppingkr_v4';
        font-size:26px;
        display: flex;
        content: "\\ea2c";
        align-items: center;
        justify-content: center;
        height: 36px;
    }
`

export default Main



// WEBPACK FOOTER //
// ./src/m_header/pages/main/index.js